/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageSupplierWithData } from '../../models/page-supplier-with-data';

export interface FetchSuppliersApiV2MembersOrgSuppliersGet$Params {
  org: string;
  name?: (string | null);
  censorData?: boolean;

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function fetchSuppliersApiV2MembersOrgSuppliersGet(http: HttpClient, rootUrl: string, params: FetchSuppliersApiV2MembersOrgSuppliersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSupplierWithData>> {
  const rb = new RequestBuilder(rootUrl, fetchSuppliersApiV2MembersOrgSuppliersGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
    rb.query('name', params.name, {});
    rb.query('censorData', params.censorData, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageSupplierWithData>;
    })
  );
}

fetchSuppliersApiV2MembersOrgSuppliersGet.PATH = '/api/v2/members/{org}/suppliers';
